import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'authToken';
const PROFILE_KEY = 'userProfile';
// Keys written by older builds or tied to the signed-in user's work.
const RELATED_KEYS = ['token', 'user', 'currentProjectId', 'picraProcessingData', 'fileUploads'];
const SESSION_EVENT = 'ezpicra:session-change';

const notify = () => window.dispatchEvent(new Event(SESSION_EVENT));

const normalizeUser = (user) => {
  if (!user) return null;
  return { ...user, id: user.id || user._id };
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return typeof exp === 'number' && exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

export const hasValidToken = () => {
  const token = getToken();
  return Boolean(token) && !isTokenExpired(token);
};

export const getStoredUser = () => {
  try {
    return normalizeUser(JSON.parse(localStorage.getItem(PROFILE_KEY)));
  } catch {
    return null;
  }
};

export const setSession = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(PROFILE_KEY, JSON.stringify(normalizeUser(user)));
  notify();
};

export const updateStoredUser = (user) => {
  const merged = normalizeUser({ ...getStoredUser(), ...user });
  localStorage.setItem(PROFILE_KEY, JSON.stringify(merged));
  notify();
  return merged;
};

export const clearSession = () => {
  [TOKEN_KEY, PROFILE_KEY, ...RELATED_KEYS].forEach((key) => localStorage.removeItem(key));
  notify();
};

/** Subscribes to session changes in this tab and in other tabs. Returns an unsubscribe function. */
export const onSessionChange = (callback) => {
  const handleStorage = (event) => {
    if (event.key === null || event.key === TOKEN_KEY || event.key === PROFILE_KEY) {
      callback();
    }
  };
  window.addEventListener(SESSION_EVENT, callback);
  window.addEventListener('storage', handleStorage);
  return () => {
    window.removeEventListener(SESSION_EVENT, callback);
    window.removeEventListener('storage', handleStorage);
  };
};
